import uuid from 'uuid'
import Cookie from 'universal-cookie'
import moment from 'moment'

export default {
  namespaced: true,

  state: {
    id: null,
    pin: null,
    name: null,
    backendVersion: null,
    renewCookieTimer: null
  },

  getters: {
    id(state) {
      if (!state.id) {
        throw new Error('No identifier was created.')
      }

      return state.id
    },
    pin(state) {
      return state.pin
    },
    backendVersion(state) {
      return state.backendVersion
    },
    name(state) {
      return state.name
    }
  },

  mutations: {
    saveRenewCookieTimer(state, renewCookieTimer) {
      if (!state.renewCookieTimer) {
        console.debug('Clearing the previous renew cookie timer ...')

        // INFO: Make sure to clear the previous timer.
        clearTimeout(state.renewCookieTimer)
      }

      state.renewCookieTimer = renewCookieTimer
    },
    setPin(state, pin) {
      state.pin = pin
    },
    clearPin(state) {
      state.pin = null
    },
    setBackendVersion(state, version) {
      state.backendVersion = version
    },
    setName(state, name) {
      state.name = name
    },
    saveId(state, id) {
      state.id = id
    }
  },

  actions: {
    async init({commit, dispatch}) {
      await dispatch('renewCookie')
      renewCookieTimer(commit, dispatch)
    },
    async renewCookie({commit}) {
      const cookie = new Cookie()
      let viewerId = cookie.get('roomz-viewer-id')

      if (!viewerId) {
        viewerId = uuid()
      }

      cookie.set('roomz-viewer-id', viewerId, {expires: moment().add(1, 'month').toDate()})
      commit('saveId', viewerId)
    },
    setPin({commit}, pin) {
      commit('setPin', pin)
    },
    clearPin({commit}) {
      commit('clearPin')
    },
    setBackendVersion({commit}, version) {
      commit('setBackendVersion', version)
    },
    setName({commit}, name) {
      commit('setName', name)
    }
  }
}

function renewCookieTimer(commit, dispatch) {
  const timer = setTimeout(async () => {
      await dispatch('renewCookie')
      await renewCookieTimer(commit, dispatch)
    },
    1000 * 60 * 60 * 24 * 15) // Renew the cookie every 15 days.
  commit('saveRenewCookieTimer', timer)
}



// WEBPACK FOOTER //
// ./src/store/modules/viewer.js